import { compact } from 'lodash';

import { FeaturedLinkInterface, NearbyNodeInterface } from '@/types';
import { NodeType } from '@/types/api-types';
import { convertNodeTypeToMode } from '@/utils/format';
import { createPortPageUrl, getPreferredIdentifier } from '@/utils/helpers';

// Transforms a node array to an array of FeatureLinks
const transformNodesToNearbyLinks = (nodes: NearbyNodeInterface[] = []): FeaturedLinkInterface[] => {
  if (!nodes) return [];

  const nearbyLinks = nodes.map((node) => {
    const nodeId = getPreferredIdentifier(node.identifiers);
    const nodeType = node.type as NodeType;

    // early out if no node id
    if (!nodeId) return null;

    return {
      key: node.id,
      title: node.name,
      url: createPortPageUrl(node.identifiers),
      countryCode: node.countryCode,
      secondaryText: `${nodeId.value} • ${Math.round(node.distanceKm)}km`,
      transportType: convertNodeTypeToMode(nodeType),
    };
  });

  return compact(nearbyLinks);
};
export { transformNodesToNearbyLinks };
